import React, { useContext,useEffect } from 'react';
import { notification, Button } from 'antd';
import { Box, Text } from 'rebass';

import ContentLayout from 'layouts/ContentLayout';
import LoginForm from 'components/LoginForm';
import AuthContext from 'context/AuthContext';
import { User } from 'types/Users';
import { History } from 'history';
import { KEY_CONTENT_ROUTES, AUTHENTICATED_ROUTES } from 'routing';
import theme from 'theme';
import { ThemeProvider } from 'emotion-theming';
import SocialAuthBlock from 'components/SocialAuthBlock/SocialAuthBlock';
import { useTranslation } from 'react-i18next';
import { isUAE } from 'utils/env';
import I18n from 'utils/i18n';
import cn from 'classnames';
import { AUTH_TOKEN, getItem } from 'utils/storage';
const { TUTOR_DASHBOARD, CUSTOMER_DASHBOARD, AVAILABILITY } = AUTHENTICATED_ROUTES;
const { HOME,FORGOT_PASSWORD, SEARCH, TUTOR_CREATE_ACCOUNT, STUDENT_CREATE_ACCOUNT } = KEY_CONTENT_ROUTES;

interface LoginProps {
  history: History;
}

export default function Login({ history }: LoginProps) {
  
  
  const { t } = useTranslation()
  const auth = useContext(AuthContext);

  const continueToDashboard = () => {
    if (auth.user) {
      if (auth.user.is_tutor) {
        history.push(TUTOR_DASHBOARD);
      } else {
        history.push(CUSTOMER_DASHBOARD);
      }
    }
  };

  const onSuccess = (user: User): void => {
    let message = t('Success');
    let description = `${t('Welcome back')}, ${user.first_name}!`;

    notification.success({
      className:cn(I18n.isAr&&'isarNotification'),
      duration: 8,
      message: !user.is_customer ? t('Hello tutors!') : message,
      description: !user.is_customer ? <span>{t('Tutors with frequently updated calendars and fast response times are receiving significantly more bookings The more you interact with the platform, the higher your profile will appear in the search results')} <a href={AVAILABILITY}>{t('Update Now!')}</a></span> : description,
    });

    if (history.location.state) {
      const redirect = history.location.state.from.pathname;
      history.push(redirect);
    } else {
      history.push(HOME);
      // if (user.is_tutor) {
      //   history.push(TUTOR_DASHBOARD);
      // } else {
      //   history.push(CUSTOMER_DASHBOARD);
      // }
    }
    window.location.reload()
  };

  const onError = (error: string = t('Something went wrong')): void => {
    notification.error({
      className:cn(I18n.isAr&&'isarNotification'),
      message: t('Error'),
      description: error
    });
  };
    // 返回顶部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <ThemeProvider  theme={theme}>
      <ContentLayout style={isUAE?{backgroundColor:'#f8f4fb'}:{}}>
        <Box
          maxWidth="432px"
          width="100%"
          height="100%"
          ml="auto"
          mr="auto"
          px={3}
        >
          {getItem(AUTH_TOKEN) ? (
            <Button type="primary" onClick={continueToDashboard}>
              {t('Continue to Dashboard')}
            </Button>
          ) : (
            <>
              <Text variant="signIn.mainHeading" mb={7}>
                {t('Login')}
              </Text>
              {!isUAE&&<>
                <SocialAuthBlock
                  onSuccess={onSuccess}
                  onError={onError}
                />
                <Box my={3} className="th-word-divider">
                    <span>
                        {t('or')}
                    </span>
                </Box>
              </>}
              <LoginForm
                switchToCustomerOnboarding={() => history.push(SEARCH)}
                switchToTutorOnboarding={() =>
                  history.push(TUTOR_CREATE_ACCOUNT)
                }
                switchToForgotPass={() => history.push(FORGOT_PASSWORD)}
                switchToCreateStudent={() => history.push(STUDENT_CREATE_ACCOUNT)}
                switchToCreateTutor={() => history.push(TUTOR_CREATE_ACCOUNT)}
                onSuccess={onSuccess}
                onError={onError}
              />
              <Box mb="100px" />
            </>
          )}
        </Box>
      </ContentLayout>
    </ThemeProvider>
  );
}
